document.addEventListener("DOMContentLoaded", () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const scheduleWrapper = document.querySelector('.schedule_registration');
  if (!scheduleWrapper) return;

  const ctaButtons = scheduleWrapper.querySelectorAll('.cta_btn');

  ctaButtons.forEach(cta => {
    const link = cta.querySelector('a.btn');
    if (!link) return;

    const href = link.getAttribute('href');
    const dateMatch = href.match(/end=(\d{4}-\d{2}-\d{2})/);

    if (dateMatch) {
      const endDate = new Date(dateMatch[1]);

      if (today > endDate) {
        // 1. 文言を「終了」に書き換える
        const btnText = link.querySelector('.btn_text');
        if (btnText) {
          btnText.textContent = "終了";
          // 2. .btn_text の背景色だけをピンポイントでグレーにする
          btnText.style.backgroundColor = "#b7b7b7";
          btnText.style.backgroundImage = "none"; // 元のグラデーションを消す
        }

        // 3. リンク機能を無効化する（aタグは残すが、どこにも飛ばさない）
        link.setAttribute('href', 'javascript:void(0)');
        link.style.cursor = 'default';
        link.style.pointerEvents = 'none'; // クリック反応自体をなくす

        // 4. 外枠の .cta_btn の背景なども必要に応じてリセット
        cta.style.backgroundImage = "none";
        cta.style.cursor = "default";
      }
    }
  });
});